import { formatDate } from '@shared/core/utils';
import { BaseControl } from './base';
import { FieldValidators, FormFieldSerializedValue } from '../index';
import { unserializeDate } from './helpers';
import { DateTimeString, FromTo } from '@shared/core/types';

export class DatetimeIntervalControl extends BaseControl {
  unserializeValue(): any {
    const value = this.field.value as FromTo<DateTimeString>;
    if (!value) {
      return null;
    }

    return value
      ? [
          unserializeDate(value.from, this.options.dateTimeFormat),
          unserializeDate(value.to, this.options.dateTimeFormat),
        ]
      : null;
  }

  serializeValue(formControlValue: any): FormFieldSerializedValue {
    if (formControlValue == null) {
      return null;
    }

    const [from, to] = formControlValue.map(date =>
      date == null ? null : formatDate(date, this.options.dateTimeFormat),
    );

    return {
      from,
      to,
    };
  }

  getValidatorConstraint(validatorName: keyof FieldValidators): any {
    if (!this.hasValidator(validatorName)) {
      return;
    }

    const validatorConstraint = super.getValidatorConstraint(validatorName);
    switch (validatorName) {
      case 'min':
      case 'max':
        return unserializeDate(validatorConstraint, this.options.dateTimeFormat);
      default:
        return validatorConstraint;
    }
  }
}
